// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  -ms-scroll-chaining: none;
      overscroll-behavior: none;
  -ms-touch-action: none;
      touch-action: none;
}
`, "",{"version":3,"sources":["webpack://./App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;MAAzB,yBAAyB;EACzB,sBAAkB;MAAlB,kBAAkB;AACpB","sourcesContent":["body {\n  overscroll-behavior: none;\n  touch-action: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
